import { useNavigate } from 'react-router-dom';
import { FaUserPlus } from 'react-icons/fa';
import CustomerWaitlistForm from '../components/customers/CustomerWaitlistForm';
import customerWaitlistService from '../utils/customerWaitlistService';

const CustomerNew = () => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    await customerWaitlistService.create(data);
    navigate('/dashboard/customers');
  };

  return (
    <section className="col-span-1 md:col-span-10 p-4 md:py-6">
      <div className="rounded-lg border border-slate-200 bg-slate-50/70 p-4 shadow-sm md:p-6">
        <div className="mb-6 flex flex-col justify-between gap-4 rounded-lg bg-white p-5 text-left shadow-sm md:flex-row md:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-emerald-700">
              Waitlist
            </p>
            <h2 className="mt-2 text-3xl font-semibold text-[#00595A]">
              Add Customer
            </h2>
            <p className="mt-2 text-sm text-slate-500">
              Select a product and capture required quantity with contact details.
            </p>
          </div>
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded bg-[#00595A] text-white shadow-sm">
            <FaUserPlus className="h-6 w-6" />
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm md:p-6">
          <CustomerWaitlistForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/dashboard/customers')}
          />
        </div>
      </div>
    </section>
  );
};

export default CustomerNew;
